import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import { CheckCircleIcon } from '@phosphor-icons/react';

import { SITE_THEME_PRESETS, type SiteThemePreset } from '@/lib/site-styles/theme-presets';

// Spec section 4, Step 4. Reuses the same presets Site Styles' Themes
// gallery offers later — picking one here is just applying it early, not
// a separate/parallel system. Fully editable afterward in Site Styles.
export function BrandStep({ themePreset, onChangeThemePreset }: { themePreset: SiteThemePreset; onChangeThemePreset: (preset: SiteThemePreset) => void }) {
  return (
    <Stack spacing={2.5}>
      <Typography variant="h5" sx={{ fontWeight: 700 }}>
        Pick a look
      </Typography>
      <Typography color="text.secondary">Colors, fonts, and button styles — all fully customizable later in Site Styles.</Typography>

      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' }, gap: 2 }}>
        {SITE_THEME_PRESETS.map((preset) => {
          const selected = themePreset.id === preset.id;
          return (
            <ButtonBase
              key={preset.id}
              onClick={() => onChangeThemePreset(preset)}
              sx={{
                display: 'block',
                textAlign: 'left',
                borderRadius: 2,
                overflow: 'hidden',
                border: '2px solid',
                borderColor: selected ? 'primary.main' : 'divider',
              }}
            >
              <Box sx={{ display: 'flex', height: 48 }}>
                {(['lightest', 'light', 'accent', 'dark', 'darkest'] as const).map((slot) => (
                  <Box key={slot} sx={{ flex: 1, bgcolor: preset.config.palette[slot] }} />
                ))}
              </Box>
              <Stack direction="row" sx={{ alignItems: 'center', justifyContent: 'space-between', px: 1.5, py: 1 }}>
                <Typography sx={{ fontWeight: 700 }}>{preset.name}</Typography>
                {selected ? <CheckCircleIcon size={18} weight="fill" color="var(--mui-palette-primary-main)" /> : null}
              </Stack>
            </ButtonBase>
          );
        })}
      </Box>
    </Stack>
  );
}
